var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirdeye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 48C66 61.2548 55.2548 72 42 72C38.584 72 35.3348 71.2863 32.3932 70C22.7077 64 11.7621 66.8333 7.5 69L40 4H55C53.8333 6.5 51 12.7 49 17.5C47 22.3 50.8333 25.6091 53 26.6636C60.7215 30.6525 66 38.7098 66 48ZM42 62C49.732 62 56 55.732 56 48C56 40.268 49.732 34 42 34C34.268 34 28 40.268 28 48C28 55.732 34.268 62 42 62Z",
    fill: "#F2DB1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 48,
    r: 7,
    fill: "#F2DB1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdeye);
export default __webpack_public_path__ + "static/media/Birdeye.0db8d3ac10483cadb7eb0178e652218d.svg";
export { ForwardRef as ReactComponent };